
import toast from "react-hot-toast";
import { Modal } from "./Modal";
import { InputV2 } from "../../Reusable/InputV2/InputV2";
import { Formik } from "formik";
import { Box, Spinner, Button } from "@chakra-ui/react";
import { GoalFormWrapper, MetricModalFormWrapper } from "./Styles";
import { useUpdateMetricMutation } from "../../../redux/reducers/apiSlice";
import * as yup from "yup";
import { customConsole, formatNumber, generateGraphMonthOptions, generateGraphYearOptions, revertNumberOrCurrencyFormat } from "../../utils/helper";
import * as Sentry from "@sentry/react";
import { datapointsSchema } from "../../Pages/Organizations/AddNewOrganizationForm/schema";
import { DatapointFormData } from "../../../redux/reducers/types";
import Datapoint from "../Datapoint";



const UpdateMetricModal = ({ isOpen, goalId, orgId, onClose, metric }) => {
  const [updateMetric, { isLoading: updateMetricLoading }] =
    useUpdateMetricMutation();




  const handleSubmit = async (data) => {


    let finalDatapoints = [];
    if(finalDatapoints.length >= 0){
      finalDatapoints = data.datapoints.map((datapoint: DatapointFormData) => ({ year: parseInt(datapoint.year), month: datapoint.month, target: datapoint.targetValue }));
    }

    const finalData = {
      ...metric,
      progress: {
        ...metric.progress,
        current: parseFloat(data.progress),
      },
      datapoints: finalDatapoints
    };

    delete finalData.id;
    customConsole("log", "final data", finalData);

    try {
      await updateMetric({
        orgId,
        goalId,
        metricId: metric.id,
        data: {
          ...finalData,
        },
      }).unwrap();
      toast.success(`"${metric.description}" has been edited`), onClose();
    } catch (e) {
      Sentry.captureException(e);
      toast.error(
        e?.data?.message ||
          "Something unexpected happened while trying to add your metric"
      );
    }
  };

  const generateDefaultDatapoints = () => {
    return metric.datapoints.map((datapoint: Datapoint) => ({ ...datapoint, target: formatNumber(datapoint.target, "decimal"), targetValue: revertNumberOrCurrencyFormat(datapoint.target) }))
  }


  if (updateMetricLoading) return <Spinner color="red" />;

  return (
    <Formik
      validationSchema={yup.object({
        targetType: yup.string().oneOf(['DOLLARS','PERCENTAGES', 'NUMBERS']).required(),
        progress: yup.number().when("graph_type", {
          is: 'PROGRESS_BAR',
          then: yup.number().required(),
          otherwise: yup.number().nullable()
        }),
        datapoints: datapointsSchema,
        graph_type: yup.string().oneOf(['PROGRESS_BAR', 'LINE_CHART', 'BAR_CHART']).required(),
      })}
      initialValues={{
        targetType: metric.progress.targetType,
        progress: metric.progress.current,
        datapoints: generateDefaultDatapoints() || [],
        graph_type: metric.graphType
      }}
      onSubmit={async (data) => {
        customConsole("log", "onSubmit called");
        handleSubmit(data);
      }}
    >
      {(formik) => {

        console.log("EDIT FORMIK VALUES: ", formik.values);
        console.log("EDIT FORMIK ERRORS: ", formik.errors);

        const handleCreateDatapoint = () =>{
          const datapoints = formik.values.datapoints;
          const newDatapoints = [...datapoints];
          newDatapoints.push({ year: '2025', month: 'January', target: 0})
          formik.setFieldValue('datapoints', newDatapoints);
        }

        const handleRemoveDatapoint = (i: number) => {
          const datapoints = formik.values.datapoints; 
          const newDatapoints = [...datapoints.slice(0,i),...datapoints.slice(i+1)];
          formik.setFieldValue('datapoints', newDatapoints);
        }

        return (
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            primaryButtonText={"Update"}
            secondaryButtonText={"Cancel"}
            modalTitle={"Update metric"}
            onPrimaryButtonClicked={formik.handleSubmit}
            primaryLoading={updateMetricLoading}
            disablePrimaryButton={updateMetricLoading}
          >
            <MetricModalFormWrapper>

          
            <Box padding={4}>

    
            {formik.values.graph_type === "PROGRESS_BAR" && (
                <GoalFormWrapper>
                  <InputV2
                    title="Current progress"
                    placeholder="Update the overall progress of this metric"
                    name="progress"
                    value={formik.values.progress}
                  />
                </GoalFormWrapper>
              )}
            {formik.values?.datapoints?.length > 0 && (
                <div>
                  <div style={{border: "1px solid #eee", marginTop: 32}} />
                  <h2 style={{textAlign: 'center', marginTop: 16, fontWeight: 'bold'}}>Your datapoints</h2>
                  {formik.values.graph_type !== "PROGRESS_BAR" && formik.values.datapoints && Array.isArray(formik.values.datapoints) &&  formik.values.datapoints.map((datapoint,index) => (
                    <Box mt={8}>
                      <Datapoint key={index} index={index} removeTargetType={true} title={`Datapoint #${index+1}`} formik={formik} handleRemoveDatapoint={() => handleRemoveDatapoint(index)} />
                    </Box>
                  ))}
                </div>
              )}

              {formik.values.graph_type !== "PROGRESS_BAR" && (
                <Box mt={4}>
                  <Button onClick={handleCreateDatapoint}>Add datapoint</Button>
                </Box>
              )}
        </Box>
          </MetricModalFormWrapper>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default UpdateMetricModal;
